module.exports = __webpack_public_path__ + "toBride2-we-w-b.e0628ce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-w-b.jpg
// module id = O5ng
// module chunks = 0